import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=29b06b20&"
import script from "./Question.vue?vue&type=script&lang=ts&"
export * from "./Question.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b06b20')) {
      api.createRecord('29b06b20', component.options)
    } else {
      api.reload('29b06b20', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=29b06b20&", function () {
      api.rerender('29b06b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Question.vue"
export default component.exports